/**
 * gets the current domain to keep module flexible and to avoid limiting cookies to a subdomain
 * leading dot is not part of current specifications, but it's included here for now to be safe
 * returning an empty string should set cookie to the current hostname (e.g. localhost)
 *
 * @returns {string} - likely '.nike.com'
 */
export function getDomainForCookie(hostname) {
  var dotcomArray = hostname.match(/[a-zA-Z0-9-]+\.com$/);
  return dotcomArray ? ".".concat(dotcomArray[0]) : '';
}
/**
 * @param {string|undefined} value - the value to test
 * @param {object} regex - the pattern to match
 * @param {string} valueType - a description of the value, for any error message
 * @returns {string|undefined} the value passed in
 */

export function validateCookieValue(value, regex, valueType) {
  if (!(regex.exec(value) || value === undefined)) {
    throw new Error("cannot get ".concat(valueType, ": \"").concat(value, "\" was found but failed validation"));
  }

  return value;
}
/**
 * @param {string} value - the value to test
 * @param {object} regex - the pattern to match
 * @param {string} valueType - a description of the value, for any error message
 * @returns {string} the value passed in
 */

export function validateInput(value, regex, valueType) {
  if (!regex.exec(value)) {
    throw new Error("cannot set locale: \"".concat(value, "\" is not a recognized ").concat(valueType));
  }

  return value;
}